import type { ReportSummary } from '@testflow/shared';
import { useTranslation } from 'react-i18next';
import { SeverityBars } from '../severity-bars.js';

export function SeverityCard({ severity }: { severity: ReportSummary['severity'] }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage ?? 'de';

  return (
    <section className="rounded-card border border-[var(--border)] bg-bg-surface p-4">
      <div className="mb-1 flex items-center justify-between">
        <h2 className="text-sm font-bold text-text-primary">{t('reporting.rep2')}</h2>
        <span className="font-mono text-[10.5px] text-text-muted">REP-2</span>
      </div>
      <p className="mb-3 text-[10px] text-text-muted">{t('reporting.scopeProject')}</p>
      {severity.blockerOnInScopeTotal > 0 ? (
        <div className="mb-3 rounded-btn bg-status-fail/10 px-3 py-2 text-xs text-status-fail">
          {t('reporting.blockerWarn')}
        </div>
      ) : null}
      <SeverityBars data={severity} lang={lang} />
    </section>
  );
}
